import React, { useState, useEffect } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Button } from 'telstra-ui/components/button/Button';
import { Tag } from 'telstra-ui/components/tag/Tag';
import { prepareDropDownOptionsArry } from '../../ams-homepage.actions';
import './service-filters.css';

const ServiceFilters = (props) => {
  const {
    authorableContent: {
      filterHeading,
      filterSelectPlans,
      filterServiceHeading,
      filter5G,
      filterNon5G,
      filterVoice,
      filterData,
      filterApply,
      filterCancel,
      planRecommendation,
      currentPlan,
      formFields: {
        currentServicePlans,
        recommendedServicePlans,
      },
    },
    filterOpen,
    filterApplied,
    applyFilter,
    cancelFilter,
    currentPlanList,
    filterClearAll,
  } = props;

  const [currentPlanSearch, setCurrentPlanSearch] = useState([]); // eslint-disable-line
  const [recommendPlanSearch, setRecommendPlanSearch] = useState([]);

  const recommendPlanDropDownOptionsVal = recommendedServicePlans.options.filter(plan => !plan.value.includes('Wireless'));
  const recommendPlanDropDownOptions = prepareDropDownOptionsArry(recommendPlanDropDownOptionsVal);

  const [currentPlanSearchSelected, setCurrentPlanSearchSelected] = useState([]);
  const [recommendPlanSearchSelected, setRecommendPlanSearchSelected] = useState([]);

  const [fiveGCheck, setFiveGCheck] = useState(false);
  const [nonFiveGCheck, setNonFiveGCheck] = useState(false);
  const [voiceCheck, setVoiceCheck] = useState(false);
  const [dataCheck, setDataCheck] = useState(false);

  useEffect(() => {
    setCurrentPlanSearch(currentPlanList);
    setRecommendPlanSearch(recommendPlanDropDownOptions);
  }, [currentServicePlans.options, recommendedServicePlans.options]);

  useEffect(() => {
    if (filterClearAll) {
      setCurrentPlanSearchSelected([]);
      setRecommendPlanSearchSelected([]);
      setFiveGCheck(false);
      setNonFiveGCheck(false);
      setVoiceCheck(false);
      setDataCheck(false);
    }
  }, [filterClearAll]);

  const selectCurrentPlanSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = currentPlanList.find(itm => itm.itemId === selectedDevice);
    if (deviceText && currentPlanSearchSelected.includes(deviceText.displayText) === false) {
      const selectedDevices = [...currentPlanSearchSelected, deviceText.displayText];
      setCurrentPlanSearchSelected(selectedDevices);
    }
  };

  const removeFilterSelectionCurrentPlan = (val) => {
    const selectedDevices = currentPlanSearchSelected.filter(itm => itm !== val);
    if (selectedDevices) {
      setCurrentPlanSearchSelected(selectedDevices);
    }
  };

  const selectRecommendPlanSearchOption = (event) => {
    const selectedDevice = event.target.getAttribute('data-item');
    const deviceText = recommendPlanDropDownOptions.find(itm => itm.itemId === selectedDevice);
    if (deviceText && recommendPlanSearchSelected.includes(deviceText.displayText) === false) {
      const selectedDevices = [...recommendPlanSearchSelected, deviceText.displayText];
      setRecommendPlanSearchSelected(selectedDevices);
    }
  };

  const removeFilterSelectionRecommendPlan = (val) => {
    const selectedDevices = recommendPlanSearchSelected.filter(itm => itm !== val);
    if (selectedDevices) {
      setRecommendPlanSearchSelected(selectedDevices);
    }
  };

  const searchPlanBox = (event, dropDownOptions, planSearch) => {
    const searchText = event.target.value.toLowerCase();
    const desiredText = searchText.replace(/[-[\]`~@#%!'=_&";:/.>,<{}()*+?.,\\^$|#]/g);
    const options = dropDownOptions.filter((option) => {
      const optionText = option.displayText.toLowerCase();
      const match = optionText.match(desiredText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    planSearch(options);
  };

  const changeCheckbox = (event) => {
    const checkBoxId = event.target.id;
    const checkedValue = event.target.checked;
    if (checkBoxId === 'filter-5g-checkbox') {
      if (checkedValue) {
        setNonFiveGCheck(false);
      }
      setFiveGCheck(checkedValue);
    } else if (checkBoxId === 'filter-non-5g-checkbox') {
      if (checkedValue) {
        setFiveGCheck(false);
      }
      setNonFiveGCheck(checkedValue);
    } else if (checkBoxId === 'filter-voice-checkbox') {
      if (checkedValue) {
        setDataCheck(false);
      }
      setVoiceCheck(checkedValue);
    } else if (checkBoxId === 'filter-data-checkbox') {
      if (checkedValue) {
        setVoiceCheck(false);
      }
      setDataCheck(checkedValue);
    }
  };

  const onTagClose = (e) => {
    const idValue = e.target.parentNode.id;
    const [devType, devValue] = idValue.split('|');
    const filterObj = {};

    if (devType === 'currentPlan') {
      const currentPlans = currentPlanSearchSelected.filter(itm => itm !== devValue);
      setCurrentPlanSearchSelected(currentPlans);
      filterObj.currentPlanSelected = currentPlans;
    } else {
      filterObj.currentPlanSelected = currentPlanSearchSelected;
    }
    if (devType === 'recommendPlan') {
      const recommendedPlans = recommendPlanSearchSelected.filter(itm => itm !== devValue);
      setRecommendPlanSearchSelected(recommendedPlans);
      filterObj.recommendPlanSelectId = recommendedPlans.map((itm) => {
        const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
        return device.itemId;
      });
    } else {
      filterObj.recommendPlanSelectId = recommendPlanSearchSelected.map((itm) => {
        const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
        return device.itemId;
      });
    }
    if (devType === 'fiveG') {
      setFiveGCheck(false);
      filterObj.fiveGCheck = false;
    } else {
      filterObj.fiveGCheck = fiveGCheck;
    }
    if (devType === 'nonFiveG') {
      setNonFiveGCheck(false);
      filterObj.nonFiveGCheck = false;
    } else {
      filterObj.nonFiveGCheck = nonFiveGCheck;
    }
    if (devType === 'voiceCheck') {
      setVoiceCheck(false);
      filterObj.voiceCheck = false;
    } else {
      filterObj.voiceCheck = voiceCheck;
    }
    if (devType === 'dataCheck') {
      setDataCheck(false);
      filterObj.dataCheck = false;
    } else {
      filterObj.dataCheck = dataCheck;
    }
    if (filterObj.currentPlanSelected.length === 0 &&
      filterObj.recommendPlanSelectId.length === 0 &&
      !filterObj.fiveGCheck &&
      !filterObj.nonFiveGCheck &&
      !filterObj.voiceCheck &&
      !filterObj.dataCheck
    ) {
      cancelFilter();
    } else {
      applyFilter(filterObj);
    }
  };

  const applyCancel = () => {
    setCurrentPlanSearchSelected([]);
    setRecommendPlanSearchSelected([]);
    setFiveGCheck(false);
    setNonFiveGCheck(false);
    setVoiceCheck(false);
    setDataCheck(false);
    cancelFilter();
  };

  const generateFilterTags = () => {
    let allTags = [];
    const currentPlans = currentPlanSearchSelected.map(dev => (
      {
        devType: 'currentPlan',
        devValue: dev,
      }
    ));
    allTags = [...currentPlans];

    const recommendedPlans = recommendPlanSearchSelected.map(dev => (
      {
        devType: 'recommendPlan',
        devValue: dev,
      }
    ));

    allTags = [...allTags, ...recommendedPlans];

    if (fiveGCheck) {
      allTags.push({
        devType: 'fiveG',
        devValue: filter5G,
      });
    }
    if (nonFiveGCheck) {
      allTags.push({
        devType: 'nonFiveG',
        devValue: filterNon5G,
      });
    }
    if (voiceCheck) {
      allTags.push({
        devType: 'voiceCheck',
        devValue: filterVoice,
      });
    }
    if (dataCheck) {
      allTags.push({
        devType: 'dataCheck',
        devValue: filterData,
      });
    }
    return (
      allTags.map((tag, index) => (
        <div className="tag-box" key={`tag${index + 1}`}>
          <Tag
            label={tag.devValue}
            icon="icon-navigation-close"
            iconPosition="right"
            id={`${tag.devType}|${tag.devValue}`}
            onCloseClick={onTagClose}
          />
        </div>
      ))
    );
  };

  const applyFilterSelected = () => {
    const recommendPlanSelectId = recommendPlanSearchSelected.map((itm) => {
      const device = recommendPlanDropDownOptions.find(dev => dev.displayText === itm);
      return device.itemId;
    });
    const filterArr = {
      currentPlanSelected: currentPlanSearchSelected,
      recommendPlanSelectId,
      fiveGCheck,
      nonFiveGCheck,
      voiceCheck,
      dataCheck,
    };
    applyFilter(filterArr);
  };

  return (
    <div className="service-filter-section">
      {filterOpen === false && filterApplied &&
        <div className="row">
          {generateFilterTags()}
        </div>
      }
      {filterOpen &&
        <div className="main-filter">
          <div className="row">
            <div className="col-12 heading20">
              {filterHeading}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <Dropdown
                dropdownId="filter-current-plan"
                label={currentPlan}
                values={currentPlanSearchSelected}
                searchOnChange={e => searchPlanBox(e, currentPlanList, setCurrentPlanSearch)}
                searchBox
                highlightSelected
                multiSelection
                removeFilterSelection={removeFilterSelectionCurrentPlan}
                options={currentPlanSearch}
                onOptionClick={selectCurrentPlanSearchOption}
                assistiveText={filterSelectPlans}
              />
            </div>
            <div className="col-6">
              <Dropdown
                dropdownId="filter-recommend-plan"
                label={planRecommendation}
                values={recommendPlanSearchSelected}
                searchOnChange={e => searchPlanBox(e, recommendPlanDropDownOptions, setRecommendPlanSearch)}
                multiSelection
                removeFilterSelection={removeFilterSelectionRecommendPlan}
                searchBox
                highlightSelected
                options={recommendPlanSearch}
                onOptionClick={selectRecommendPlanSearchOption}
                assistiveText={filterSelectPlans}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-8">
              <div className="row">
                <div className="col-12 heading16">
                  {filterServiceHeading}
                </div>
                <div className="col-2">
                  <Checkbox
                    id="filter-voice-checkbox"
                    onChange={changeCheckbox}
                    checked={voiceCheck}
                    label={filterVoice}
                  />
                </div>
                <div className="col-2">
                  <Checkbox
                    id="filter-data-checkbox"
                    onChange={changeCheckbox}
                    checked={dataCheck}
                    label={filterData}
                  />
                </div>
                <div className="col-4">
                  <Checkbox
                    id="filter-5g-checkbox"
                    onChange={changeCheckbox}
                    checked={fiveGCheck}
                    label={filter5G}
                  />
                </div>
                <div className="col-4">
                  <Checkbox
                    id="filter-non-5g-checkbox"
                    onChange={changeCheckbox}
                    checked={nonFiveGCheck}
                    label={filterNon5G}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row buttons-row" >
            <div className="col-3 offset-9">
              <div className="row">
                <div className="col-6">
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => applyCancel()}
                  >{filterCancel}
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    variant="primary"
                    size="small"
                    state="app"
                    onClick={() => applyFilterSelected()}
                  >{filterApply}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default ServiceFilters;
